import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { AppointmentType } from '@src/lib/__generated/vetspire/sdk';
import { mountDevTools } from '@src/store/utils/mount-dev-tools';

export enum ReasonForVisitType {
	RoutineCheckUp = 'Routine Check Up',
	SickNeeds = 'Sick Needs',
}

export const visitDuration = {
	[ReasonForVisitType.RoutineCheckUp]: 30,
	[ReasonForVisitType.SickNeeds]: 30,
};

type ReasonForVisitState = {
	mainReasonForVisit: ReasonForVisitType | null;
	appointmentTypes: AppointmentType[];
	reasonsForVisitList: string[];
	openedReasonExplanations: boolean;
};

type ReasonForVisitActions = {
	setMainReasonForVisit: (mainReasonForVisit: ReasonForVisitType | null) => void;
	setAppointmentTypes: (appointmentTypes: AppointmentType[]) => void;
	setReasonsForVisitList: (reasonsForVisitList: string[]) => void;
	setOpenedReasonExplanations: (openedExplanations: boolean) => void;
	reset: () => void;
};

const INITIAL_STATE: ReasonForVisitState = {
	mainReasonForVisit: null,
	appointmentTypes: [],
	reasonsForVisitList: [],
	openedReasonExplanations: false,
};

const useReasonForVisitStore = create<ReasonForVisitState & ReasonForVisitActions>()(
	persist(
		(set) => ({
			...INITIAL_STATE,
			setMainReasonForVisit: (mainReasonForVisit) => set({ mainReasonForVisit }),
			setAppointmentTypes: (appointmentTypes) => set({ appointmentTypes }),
			setReasonsForVisitList: (reasonsForVisitList) => set({ reasonsForVisitList }),
			setOpenedReasonExplanations: (openedReasonExplanations) => set({ openedReasonExplanations }),
			reset: () => set(INITIAL_STATE),
		}),
		{ name: 'book-an-appointment-reason-for-visit' }
	)
);

mountDevTools('useReasonForVisitStore', useReasonForVisitStore);

export default useReasonForVisitStore;
